<template>
    <div class="w-full h-full">
        <div v-if="canAddorEditTransactions" class="flex w-full justify-end mb-2"><base-button-affirmative @click="openAddTransactionForm"><div class="text-base">Add Transaction</div></base-button-affirmative></div>
        <div class="grid grid-cols-2 gap-2 w-full px-4 max-h-5/6">
            <ClientTransactionCard v-for="transaction in client.transactions" :companies="companies" :client="client" :key="transaction.id" :transaction="transaction" @refetch-clients="refetchClients"/>
        </div>
        <base-modal
                :is-form-visible="showAddTransactionForm"
                @close="closeAddTransactionForm">
              <template v-slot:header>
                Add Transaction
              </template>
              <template v-slot:body>
                <AddClientTransactionForm @add-transaction="addTransaction" @close="closeAddTransactionForm" :client="client" :companies="companies" />
              </template>
        </base-modal>
    </div>
</template>

<script setup>
import { defineProps, ref, computed, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { addClientTransaction, getClientCompanies } from '@/services/Client';
import ClientTransactionCard from './client-transaction-components/ClientTransactionCard.vue';
import AddClientTransactionForm from './client-transaction-components/AddClientTransactionForm.vue';

const props = defineProps([
    'client'
])

const emit = defineEmits([
    'refetch-clients'
])

const store = useStore()
const $toast = useToast()

const canAddorEditTransactions = computed(() => {
    let userPermissionsStore = store.getters['auth/showUserPermissions']
    return userPermissionsStore.isEditClientTransactions || userPermissionsStore.isDev
})

const showAddTransactionForm = ref(false)
const companies = ref([])

function openAddTransactionForm(){
    showAddTransactionForm.value = true
}

function closeAddTransactionForm(){
    showAddTransactionForm.value = false
}

function refetchClients(){
    emit('refetch-clients')
}

async function addTransaction(transactionData){
    const token = store.state.auth.token
    // const data = {
    //     transaction_data: transactionData
    // }
    const result = await addClientTransaction(token, props.client.id, transactionData)
    if(result.status == 201){
        $toast.open({
            message: 'Successfully added transaction',
            type: 'success',
            duration: 3000
        })
        refetchClients()
        closeAddTransactionForm()
    } else {
        $toast.open({
            message: 'Error, could not add transaction',
            type: 'error',
            duration: 3000
        })
    }
}

async function loadCompanies(){
    const token = store.state.auth.token
    const result = await getClientCompanies(token, props.client.id)
    if(result.status == 200){
        companies.value = result.data.companies
    }
}

loadCompanies()

</script>